/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function ParametersDisplayUpdatedReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeParametersDisplayUpdatedAction } action:
 *     action de l'application
 * @return { Reducer }
 */
export const ParametersDisplayUpdatedReducer:
    Reducer<CombinesObjectModels<any>> =
        (state: any =
             {

             },
         action: actionsTypesFromStore.TypeParametersDisplayUpdatedAction) => {
          switch (action.type) {
            case actions.ParametersDisplayUpdatedActionTypes
                .PARAMETERDISPLAYUPDATED_INPROGRESS:

              return {
                loading: true, ...state
              }

              break;
            case actions.ParametersDisplayUpdatedActionTypes
                .PARAMETERDISPLAYUPDATED_FAIL:

              return {
                error: action.payload.error, loading: false,
              }

              break;

            case actions.ParametersDisplayUpdatedActionTypes
                .PARAMETERDISPLAYUPDATED_SUCCESS:

              return {
                data: action.payload.data, loading: false,
              }

              break;

            default:
              return state
              break;
          }
        }


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/supervision/display/updated/index.ts